/*!
 * Copyright © 2024. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { IVideoDeviceInfo } from '../../../../core/models/video-device-info.interface';

@Component({
  selector: 'fm-video-request-modal',
  templateUrl: './video-request-modal.component.html',
  styleUrls: ['./video-request-modal.component.scss']
})
export class VideoRequestModalComponent {
  constructor(
    public dialogRef: MatLegacyDialogRef<VideoRequestModalComponent>,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: { returnBackToVideo: boolean; videoDeviceInfo: Observable<IVideoDeviceInfo> },
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  closeModal(deleteItems: boolean) {
    this.dialogRef.close(deleteItems);
  }

  openVideoEventsPage() {
    this._document.defaultView.location.href = `/integratedvideo/`;
  }
}
